import React from 'react';
import MarketServiceGenericService from "./MarketServiceGenericService";

function GeographyStoreLevelAllowabilityService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/marketsGeographyStoreLevelAllowability/`;
    return (<MarketServiceGenericService
        endpointUrl={endpointUrl}
        pageName={"Geography Store Level Allowability Service"}
    />);
}

export default GeographyStoreLevelAllowabilityService;